import type { SetupStep, SetupStepItem } from '../integrationConfig'

const MCP_URL_PLACEHOLDER = 'MCP_SERVER_URL'

function transformStepItem(item: SetupStepItem, mcpUrl: string): SetupStepItem {
  if (typeof item === 'string') {
    return item.replaceAll(MCP_URL_PLACEHOLDER, mcpUrl)
  }
  return {
    ...item,
    text: item.text.replaceAll(MCP_URL_PLACEHOLDER, mcpUrl),
    ...(item.displayText && {
      displayText: item.displayText.replaceAll(MCP_URL_PLACEHOLDER, mcpUrl),
    }),
    ...(item.copyText && {
      copyText: item.copyText.replaceAll(MCP_URL_PLACEHOLDER, mcpUrl),
    }),
  }
}

function injectMcpUrlIntoStep(step: SetupStep, mcpUrl: string): SetupStep {
  const transformedStep: SetupStep = { ...step }

  if (step.code) {
    transformedStep.code = step.code.replaceAll(MCP_URL_PLACEHOLDER, mcpUrl)
  }

  if (step.copyCode) {
    transformedStep.copyCode = step.copyCode.replaceAll(
      MCP_URL_PLACEHOLDER,
      mcpUrl,
    )
  }

  if (step.windowsCode) {
    transformedStep.windowsCode = step.windowsCode.replaceAll(
      MCP_URL_PLACEHOLDER,
      mcpUrl,
    )
  }

  if (step.windowsCopyCode) {
    transformedStep.windowsCopyCode = step.windowsCopyCode.replaceAll(
      MCP_URL_PLACEHOLDER,
      mcpUrl,
    )
  }

  if (step.items) {
    transformedStep.items = step.items.map((item) =>
      transformStepItem(item, mcpUrl),
    )
  }

  return transformedStep
}

export function injectMcpUrlIntoSteps(
  steps: SetupStep[],
  mcpUrl: string,
): SetupStep[] {
  return steps.map((step) => injectMcpUrlIntoStep(step, mcpUrl))
}
